
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { LoginService } from '../loginservice/login.service';
import { UserService } from './session.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

    const token = sessionStorage.getItem('token')
    if (token) {
        const clonedReq = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
        return next(clonedReq);
    }
    
    return next(req);
}
      